<div class="collection-type-toggle-for-inline">
    <ng-container *ngFor="let item of items; trackBy: trackerFn; let i = index">
        <div class="collection-type-toggle-for-inline__sep" *ngIf="i">/</div>
        <shared-link class="collection-type-toggle-for-inline__item" [ngClass]="{'is-active': item.IsActive === true}"
            [inverted]="inverted" (onClick)="handleLinkClick($event, item)">{{item.Name | uppercase}}</shared-link>
    </ng-container>
</div>